import { ChipsComponent } from './../components/chips/chips.component'
import { SessionService } from './../services/session.service'
import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { appRoutingProviders } from '../auth.guard'
import { SettingsService } from '../services/settings.service'
import { RequestService } from '../services/request.service'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
// import { QuillModule } from 'ngx-quill'
import { SelectModule } from 'ng-select'
import { AgmCoreModule } from 'angular2-google-maps/core'

const imports: any = [
	CommonModule,
	FormsModule,
	ReactiveFormsModule,
	// QuillModule,
	SelectModule,
	AgmCoreModule,
	NgbModule
]

const declarations: any = [
	ChipsComponent
]

const ex = imports.concat(declarations)

@NgModule({
	imports: imports,
	declarations: declarations,
	exports: ex
	// providers: [NgbModal]
})
export class SharedModule {
	static forRoot(): ModuleWithProviders {
		return {
			ngModule: SharedModule,
			providers: [
				appRoutingProviders,
				SessionService,
				SettingsService,
				RequestService
			]
		};
	}
}


// WEBPACK FOOTER //
// D:/jordan/stunii-cms-stunii-cms-Appzorro1/stunii-cms-stunii-cms-Appzorro1/src/app/modules/shared.module.ts